import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import formatDisplayDate from 'syf-js-utilities/formats/formatDisplayDate';
import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
export const getFilteredPromotions = (promotions, filterBy) => filterBy === 'active'
    ? promotions === null || promotions === void 0 ? void 0 : promotions.filter((promotion) => promotion[filterBy])
    : promotions === null || promotions === void 0 ? void 0 : promotions.filter((promotion) => !promotion.active);
export const getFormattedDate = ({ date, expirationDateLabel, monthFormat = 'MMM' }) => {
    const language = getLanguageFromStorage();
    if (date === null || date.match(/0000-00-00/)) {
        return expirationDateLabel;
    }
    if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return formatDisplayDate(date, language, monthFormat);
    }
    return date;
};
export const getPromotionsFilteredData = (promotions) => {
    const promotionsFilteredData = {
        active: [],
        expired: []
    };
    promotionsFilteredData.active = getFilteredPromotions(promotions, 'active');
    promotionsFilteredData.expired = getFilteredPromotions(promotions);
    return promotionsFilteredData;
};
export const getPromotions = (data) => {
    if (data && Object.keys(data === null || data === void 0 ? void 0 : data.promotions).length > 0) {
        return data.promotions;
    }
    return [];
};
export const getAccordionIcon = toggle => (toggle ? faAngleUp : faAngleDown);
//# sourceMappingURL=promotions-utils.js.map